module.exports = {
    ENV: 'prod',
    APP_NAME: 'epo',
    END_POINT: 'https://ssm.services.apihf.com',
    API_KEY: 'WWBdKSCyRO6SnKwC88E8R5dRt0MwiGQprJDfKKD5',
    BRAND_KEY: '20b4d495-ba78-4050-b208-f5205f18f96f',
    LANG: 'fr-FR'
}